import { useState } from 'react';
import './App.css';
import MarkItem from './components/MarkItem';

function App() {

  const [todoTitle, setTodoTitle] = useState('');
  const [todoArray, setTodoArray] = useState([]);

  const handleAddTodo = () => {
    setTodoArray([...todoArray, todoTitle]);
    console.log(todoArray);
    setTodoTitle('');
  }

  const handleDelete = (indextoDelete) => {
    setTodoArray((prev) =>
      prev.filter((_, index) => index !== indextoDelete)
    );
  }

  return (
    <div className="App">
      <div className='todo-box'>
        <div className='heading-box'>
          <span className='to'><h2>TO</h2></span>
          <span className='do'><h2>DO</h2></span>
        </div>
        <div className='input-item'>
          <span>
            <input 
              className='input-box' 
              placeholder='What do you need to do?'
              value={todoTitle}
              onChange={(e) => {setTodoTitle(e.target.value)}}
            />
          </span>
          <span 
            className='add-button'
            onClick={handleAddTodo}
          >Add</span>
        </div>
        <div className='todo-area'>
          {todoArray.length !==0 ?
            todoArray.map((item, index) => {
              return(
                <MarkItem
                  key={index}
                  name={item}
                  onDelete={() => handleDelete(index)}
                />
              )
            }) : "Add todos to see it here..."
          }
        </div>
      </div>
    </div>
  );
}

export default App;
